module.exports = __webpack_public_path__ + "img/relax.aee8c8c8.png";